const AUTH_RETURN_TO_KEY = 'gaia.auth.returnTo';

const normalizeReturnTo = (returnTo) => {
  if (!returnTo || typeof returnTo !== 'string') {
    return null;
  }
  if (!returnTo.startsWith('/')) {
    return null;
  }
  if (returnTo === '/callback') {
    return null;
  }
  return returnTo;
};

export const setAuthReturnTo = (returnTo) => {
  const normalized = normalizeReturnTo(returnTo);
  if (!normalized || typeof window === 'undefined') {
    return;
  }
  try {
    window.sessionStorage.setItem(AUTH_RETURN_TO_KEY, normalized);
  } catch {
    // Ignore storage failures (private mode, disabled storage, etc.)
  }
};

export const getAuthReturnTo = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const stored = window.sessionStorage.getItem(AUTH_RETURN_TO_KEY);
    return normalizeReturnTo(stored);
  } catch {
    return null;
  }
};

export const clearAuthReturnTo = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
  } catch {
    // Ignore storage failures (private mode, disabled storage, etc.)
  }
};

export const consumeAuthReturnTo = () => {
  const stored = getAuthReturnTo();
  if (stored) {
    clearAuthReturnTo();
  }
  return stored;
};
